import TicketmasterEvents from "./TicketmasterEvents";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TicketmasterEvents />
    </QueryClientProvider>
  );
}

export default App;
